module.exports = __webpack_public_path__ + "img/euro_normal_vwfs.f3e46363.svg";